import { render, staticRenderFns } from "./templateAddress.vue?vue&type=template&id=8483cea6&scoped=true"
import script from "./templateAddress.vue?vue&type=script&lang=js"
export * from "./templateAddress.vue?vue&type=script&lang=js"
import style0 from "./templateAddress.vue?vue&type=style&index=0&id=8483cea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8483cea6",
  null
  
)

export default component.exports